import React from "react";
import { Instagram, Facebook, Linkedin, Youtube } from "lucide-react";
import { PUBLISHED_SOCIAL } from "../lib/social";

const ICONS = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin, youtube: Youtube };

/**
 * Understated social icon row. Renders nothing until at least one verified
 * official PKM profile url exists in src/lib/social.js — so it never shows an
 * empty or placeholder state. Monochrome, inherits color, subtle gold hover.
 */
export const SocialLinks = ({
    label,
    labelClass = "overline text-gold/80 mb-4",
    className = "",
    iconClass = "w-5 h-5",
    linkClass = "opacity-70 hover:opacity-100 hover:text-gold transition-all duration-300",
}) => {
    if (PUBLISHED_SOCIAL.length === 0) return null;
    return (
        <div className={className} data-testid="social-links">
            {label ? <p className={labelClass}>{label}</p> : null}
            <div className="flex items-center gap-5">
                {PUBLISHED_SOCIAL.map((s) => {
                    const Icon = ICONS[s.key];
                    if (!Icon) return null;
                    return (
                        <a
                            key={s.key}
                            href={s.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Pacific Key Management on ${s.label}`}
                            data-testid={`social-link-${s.key}`}
                            className={linkClass}
                        >
                            <Icon className={iconClass} strokeWidth={1.5} />
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default SocialLinks;
